export default {
  comparePlans: 'Compare Plans',
  plan1: 'Plan 1',
  plan2: 'Plan 2',
  selectPlanToCompare: 'Please select a Plan to compare',
  betaOptimizerTooltip: 'This plan uses the new optimizer (beta)',
  fullPeriodSummary: 'Full Period Summary',
  monthlyDetailView: 'Monthly Detail View',
  weeklyDetailView: 'Weekly Detail View',
  touchpoints: 'Touchpoints',
  segments: 'Segments'
}
